export default __webpack_public_path__ + "static/media/10.04b3d5a8.jpg";